import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showAll: false,
    isMNR: true
}

const mnrCommonSlice = createSlice({
    name: 'mnrCommon',
    initialState,
    reducers: {
        showAll: (state, action) => {
            state.showAll = action.payload;
        },
        isMNR: (state, action) => {
            state.isMNR = action.payload;
        }
    }
})

export const { showAll, isMNR } = mnrCommonSlice.actions;
export default mnrCommonSlice.reducer